import { IFormItem } from '@components/Form/FormItem/FormItem';

import { RoleWithPermissionsResponse } from '@/api/roles/types';
import { UserStatusLabel } from '@/shared/users/enums';
import { enumToOptions } from '@/utils/utils';

export const userFormSchema = (
  allRoles: RoleWithPermissionsResponse[],
  hideSendStatusMailRadio?: boolean,
) =>
  [
    {
      label: 'Фамилия',
      key: 'lastName',
      type: 'text',
      disabled: true,
    },
    {
      label: 'Имя',
      key: 'firstName',
      type: 'text',
      disabled: true,
    },
    {
      label: 'Отчество',
      key: 'middleName',
      type: 'text',
      disabled: true,
    },
    {
      label: 'Организация',
      key: 'organizationName',
      type: 'text',
      disabled: true,
    },
    {
      label: 'Статус',
      key: 'status',
      type: 'select',
      payload: {
        options: enumToOptions(UserStatusLabel),
      },
      disabled: true,
    },
    {
      label: 'Роль',
      key: 'roleNames',
      type: 'select',
      payload: {
        options: allRoles,
        showSearch: true,
        optionFilterProp: 'description',
        mode: 'multiple',
        fieldNames: {
          label: 'description',
          value: 'name',
          options: 'options',
          groupLabel: 'label',
        },
      },
    },
    {
      label: 'Должность',
      key: 'position',
      type: 'text',
      disabled: true,
    },
    {
      label: 'E-mail',
      key: 'email',
      type: 'text',
      disabled: true,
    },
    {
      label: 'Номер телефона',
      key: 'phone',
      type: 'text',
      disabled: true,
    },
    {
      label: 'Отправлять ежедневную сводку',
      key: 'sendStatusMail',
      type: 'text',
      hidden: () => hideSendStatusMailRadio,
      disabled: true,
    },
    { label: 'Дата создания', key: 'createdAt', type: 'date', disabled: true },
  ] as IFormItem[];
